"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlexChild = exports.FlexColumn = exports.FlexRow = exports.FlexContainer = void 0;

var _chunkB2edacfb = require("./chunk-b2edacfb.js");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = (0, _chunkB2edacfb.a)(["\n  order: ", ";\n  flex: ", ";\n  align-self: ", ";\n\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  flex-basis: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _chunkB2edacfb.a)(["\n  display: flex;\n\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n\n  align-items: ", ";\n  align-content: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FlexContainer = _styledComponents.default.div.withConfig({
  displayName: "flex__FlexContainer",
  componentId: "smkax1-0"
})(_templateObject(), function (props) {
  return props.direction || "row";
}, function (props) {
  return props.wrap || "nowrap";
}, function (props) {
  return props.justify || "flex-start";
}, function (props) {
  return props.alignItems || props.alignitems || "stretch";
}, function (props) {
  return props.alignContent || props.aligncontent || "stretch";
});

exports.FlexContainer = FlexContainer;
var FlexRow = (0, _styledComponents.default)(FlexContainer).attrs({
  direction: "row"
});
exports.FlexRow = FlexRow;
var FlexColumn = (0, _styledComponents.default)(FlexContainer).attrs({
  direction: "column"
});
exports.FlexColumn = FlexColumn;

var FlexChild = _styledComponents.default.div.withConfig({
  displayName: "flex__FlexChild",
  componentId: "smkax1-1"
})(_templateObject2(), function (props) {
  return props.order || 0;
}, function (props) {
  return props.flex || "0 1 auto";
}, function (props) {
  return props.alignSelf || props.alignself || "auto";
}, function (props) {
  return props.grow || 0;
}, function (props) {
  return props.shrink || 1;
}, function (props) {
  return props.basis || "auto";
});

exports.FlexChild = FlexChild;